// extracted by mini-css-extract-plugin
export default {"button-container":"TablePaginationButtons_button-container__zLNbh","page-button-text":"TablePaginationButtons_page-button-text__Xw-Q-"};